import { FILTER_NAME_ATTRIBUTE_MAP } from '@app/[lang]/collections/utilities/filter-name-attribute-map';
import omit from 'lodash.omit';
import startCase from 'lodash.startcase';
import qs from 'qs';

export function filtersToFromUrlQuery(filters: any[], reverse = false) {
    const allFilterKeys = [
        ...FILTER_NAME_ATTRIBUTE_MAP.map((entry) =>
            Object.keys(entry)[0].toLowerCase()
        ),
        'sort',
    ];

    if (reverse) {
        return filters.flatMap(([label, values]) => {
            if (!allFilterKeys.includes(label)) return [];

            const map = FILTER_NAME_ATTRIBUTE_MAP.find((map) => {
                const [key] = Object.entries(map)[0];
                if (label === key.toLowerCase()) return map;
            });

            const id = Object.values(map || {})[0];
            const key = id.split('.').pop();

            return values.split(',').map((value) => {
                let input = {};

                if (label === 'size') {
                    input = {
                        variantOption: {
                            value,
                            name: key,
                        },
                    };
                } else {
                    input = {
                        productMetafield: {
                            key,
                            value,
                            namespace: 'custom',
                        },
                    };
                }

                return {
                    id: `${id}.${value.toLowerCase()}`,
                    label: startCase(value),
                    input: JSON.stringify(input),
                };
            });
        });
    }

    const filterQueries = filters.reduce((acc, { id, input }) => {
        if (!id) return acc;

        const [_, key] = id.split('.').reverse();
        const map = FILTER_NAME_ATTRIBUTE_MAP.find((map) => {
            const [_, value] = Object.entries(map)[0];
            if (value.includes(key)) return map;
        });

        const value =
            key === 'size'
                ? JSON.parse(input).variantOption.value
                : JSON.parse(input).productMetafield.value;

        const label = Object.keys(map || {})[0].toLowerCase();

        if (!acc[label]) {
            acc[label] = value;
        } else {
            acc[label] = [...acc[label].split(','), value].join();
        }
        return acc;
    }, {});

    const urlParams = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
    });

    const diff = omit(urlParams, allFilterKeys);

    return { ...filterQueries, ...diff };
}
